import React from 'react';
import { motion } from 'framer-motion';
import { imageVariants, textVariants, containerVariants } from '../../script/animationVariants';

const GenelBilgi = ({ system, id1, id2, id3 }) => {
  return (
    <motion.div 
      variants={containerVariants} 
      initial="hidden" 
      animate="visible"
    >
      <div className='grid grid-cols-1 md:grid-cols-2 gap-10'>
        <motion.div 
          className='' 
          variants={textVariants}
        >
          <div className='font-light text-20'>
            {system.generalInformationText.map((info, index) => (
              <motion.p 
                key={index} 
                variants={textVariants}
              >
                {info}
              </motion.p>
            ))}
          </div>
        </motion.div>

        <motion.div 
          className='' 
          variants={imageVariants}
        >
          <motion.img
            src={`/images/systems/${id1}/${id2}/${id3}/system-general-information/main.jpg`}
            className='aspect-video object-cover h-full w-full'
            variants={imageVariants}
          />
        </motion.div>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 my-10'>
        {system.generalInformationsDetailImage.map((image, index) => (
          <motion.img
            key={index}
            src={`/images/systems/${id1}/${id2}/${id3}/system-general-information/dimensions/${image}.jpg`}
            className='aspect-video object-contain'
            variants={imageVariants}
            whileHover={{ scale: 1.1 }} 
          />
        ))}
      </div>
    </motion.div>
  );
};

export default GenelBilgi;
